/**
 * SupplierLayout.jsx
 * ──────────────────
 * Minimal full-screen mobile layout for all supplier screens.
 * No sidebar, no hamburger, no desktop nav.
 * Provides outdoor/indoor mode toggle and status bar.
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLauncherContext } from '../shared/hooks/useLauncherContext';
import './SupplierLayout.css';

const LS_KEY = 'tmg_outdoor';

function loadOutdoor() {
  try { return localStorage.getItem(LS_KEY) === '1'; } catch { return false; }
}

function saveOutdoor(v) {
  try { localStorage.setItem(LS_KEY, v ? '1' : '0'); } catch { /* ignore */ }
}

function formatTime() {
  const now = new Date();
  let h = now.getHours();
  const m = String(now.getMinutes()).padStart(2, '0');
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${h}:${m} ${ampm}`;
}

export default function SupplierLayout({ children }) {
  const navigate = useNavigate();
  const isLauncherContext = useLauncherContext();
  const [outdoor, setOutdoor] = useState(loadOutdoor);
  const [time, setTime] = useState(formatTime);

  useEffect(() => {
    const id = setInterval(() => setTime(formatTime()), 60000);
    return () => clearInterval(id);
  }, []);

  function toggleOutdoor() {
    setOutdoor(prev => {
      const next = !prev;
      saveOutdoor(next);
      return next;
    });
  }

  return (
    <div className={`supplier-layout ${outdoor ? 'outdoor-mode' : ''}`}>
      {/* ── Status bar ────────────────────────────────────────────────── */}
      <div className="sl-status-bar">
        <button className="sl-home-btn" onClick={() => navigate(isLauncherContext ? '/home' : '/registry')}>&larr; Home</button>
        <span className="sl-time">{time}</span>
        <button className="sl-toggle-pill" onClick={toggleOutdoor}>
          {outdoor ? 'INDOOR' : 'OUTDOOR'}
        </button>
        <span className="sl-logo">TMG</span>
      </div>

      {/* ── Screen content ────────────────────────────────────────────── */}
      <div className="sl-content">
        {children}
      </div>
    </div>
  );
}
